import { makeOperationsApiCall } from './utils'

/* MUTATIONS */

export const createProduceThresholdMessage = async params => {
  try {
    const mutation = /* GraphQL */ `
      mutation createProduceThresholdMessage(
        $name: String!
        $priority: ProduceThresholdMessagePriority!
        $config: GraphQLJSON!
        $message: String!
        $processing_method: ProduceThresholdMessageProcessingMethod!
      ) {
        createProduceThresholdMessage(
          name: $name
          priority: $priority
          config: $config
          message: $message
          processing_method: $processing_method
        ) {
          id
          name
          priority
          config
          message
          processing_method
        }
      }
    `

    const { data, error } = await makeOperationsApiCall({
      mutation,
      params,
      queryKey: 'createProduceThresholdMessage',
      resultKey: 'data'
    })
    return { produceThresholdMessage: data ?? {}, error: error || null }
  } catch (err) {
    return { produceThresholdMessage: {}, error: err.message }
  }
}

export const updateProduceThresholdMessage = async params => {
  try {
    const mutation = /* GraphQL */ `
      mutation updateProduceThresholdMessage(
        $produceThresholdMessageId: String!
        $name: String!
        $priority: ProduceThresholdMessagePriority!
        $config: GraphQLJSON!
        $message: String!
        $processing_method: ProduceThresholdMessageProcessingMethod!
      ) {
        updateProduceThresholdMessage(
          produceThresholdMessageId: $produceThresholdMessageId
          name: $name
          priority: $priority
          config: $config
          message: $message
          processing_method: $processing_method
        ) {
          id
          name
          priority
          config
          message
          processing_method
        }
      }
    `

    const { data, error } = await makeOperationsApiCall({
      mutation,
      params,
      queryKey: 'updateProduceThresholdMessage',
      resultKey: 'data'
    })
    return { produceThresholdMessage: data ?? {}, error: error || null }
  } catch (err) {
    return { produceThresholdMessage: {}, error: err.message }
  }
}

/* QUERIES */

export const getProduceThresholdMessages = async params => {
  try {
    const query = /* GraphQL */ `
      query getProduceThresholdMessages(
        $limit: Int
        $offset: Int
        $order: OrderEnum
      ) {
        getProduceThresholdMessages(
          limit: $limit
          offset: $offset
          order: $order
        ) {
          produceThresholdMessages {
            id
            name
            priority
            config
            message
            processing_method
          }
          count
        }
      }
    `
    const { data, error } = await makeOperationsApiCall({
      query,
      params,
      queryKey: 'getProduceThresholdMessages',
      resultKey: 'data'
    })
    return {
      produceThresholdMessages: data?.produceThresholdMessages ?? [],
      totalCount: data?.count ?? 0,
      error: error || null
    }
  } catch (err) {
    return { produceThresholdMessages: [], totalCount: 0, error: err.message }
  }
}

export const deleteProduceThresholdMessage = async params => {
  try {
    const query = /* GraphQL */ `
      mutation deleteProduceThresholdMessage(
        $produceThresholdMessageId: String!
      ) {
        deleteProduceThresholdMessage(
          produceThresholdMessageId: $produceThresholdMessageId
        ) {
          id
          name
          priority
          config
          message
          processing_method
        }
      }
    `

    const { data, error } = await makeOperationsApiCall({
      query,
      params,
      queryKey: 'deleteProduceThresholdMessage',
      resultKey: 'data'
    })

    return { produceThresholdMessage: data ?? {}, error: error ?? null }
  } catch (err) {
    return { produceThresholdMessage: {}, error: err.message }
  }
}

export const getProduceThresholdMessage = async params => {
  try {
    const query = /* GraphQL */ `
      query getProduceThresholdMessage($produceThresholdMessageId: String!) {
        getProduceThresholdMessage(
          produceThresholdMessageId: $produceThresholdMessageId
        ) {
          id
          name
          priority
          config
          message
          processing_method
        }
      }
    `

    const { data, error } = await makeOperationsApiCall({
      query,
      params,
      queryKey: 'getProduceThresholdMessage',
      resultKey: 'data'
    })
    return { produceThresholdMessage: data ?? {}, error: error || null }
  } catch (err) {
    return { produceThresholdMessage: {}, error: err.message }
  }
}
